import React from 'react';
import { observer } from 'mobx-react';
import AddressCard from 'apps/addresses/blocks/AddressCard';
// import { AddressModel } from 'generated/models';
import { Banner } from 'components';
import { Section, SectionContent } from '../../shared/layout';
import { ShippingDetailsForm } from './ShippingDetailsForm';

export const ShippingDetails = observer(({ shipmentQuoteAppManager }: any) => {
  let warning = null;
  let warning2 = null;

  const address = shipmentQuoteAppManager.addresses[0];
  const addressCard = address && <AddressCard address={address} />;
  /* 
        // debug code - to see if addresses really differ
        address = shipmentQuoteAppManager.addresses.map((addr: AddressModel) => (
        <div key={addr.id}>
          <AddressCard address={addr} key={addr.id} />
          <span>{addr.id}</span>
        </div>
      )); */
  if (shipmentQuoteAppManager.addresses.length === 0) {
    // TODO: We should list mismatched addresses and RFQ numbers/links here
    // possibly let the user select which address to use.
    const text =
      'None of the selected RFQs have addresses. Please add an address to at least one of the RFQs.';
    warning = <Banner text={text} variant='warning' />;
  } else {
    if (shipmentQuoteAppManager.addresses.length > 1) {
      // TODO: We should list mismatched addresses and RFQ numbers/links here
      // possibly let the user select which address to use.
      const text =
        'Warning: RFQs with multiple addresses have been selected. Please ensure that all addresses are the same. If you are sure that this is the desired address for all RFQs, please proceed.';
      warning = <Banner text={text} variant='warning' />;
    }
    if (shipmentQuoteAppManager.someEmptyAddresses) {
      const text =
        'Warning: Some RFQs have no address. Please ensure all added RFQs have an address. If you are sure that this is the desired address for all RFQs, please proceed.';
      warning2 = <Banner text={text} variant='warning' />;
    }
  }
  return (
    <Section title='Shipping Details'>
      <SectionContent sx={{ paddingTop: 0 }}>
        {addressCard}
        {warning}
        {warning2}
        {!shipmentQuoteAppManager.areThereInstantQuotes && (
          <ShippingDetailsForm
            formStore={shipmentQuoteAppManager.shippingQuoteFormStore}
          />
        )}
      </SectionContent>
    </Section>
  );
});
